function sortById(a, b) {
  return a.id > b.id ? 1 : -1;
}
export {
  sortById
};
//# sourceMappingURL=sort.mjs.map
